import React from "react";

export default function HamburgerIcon() {
  return (
    <span
      className="flex h-9 w-10 flex-col items-end justify-center gap-[6px]"
      aria-hidden="true"
    >
      <span className="block h-[2px] w-5 rounded-full bg-white shadow-[0_0_10px_rgba(255,255,255,0.28)] transition duration-200 group-hover:w-6 group-hover:bg-white" />
      <span className="block h-[2px] w-7 rounded-full bg-white shadow-[0_0_10px_rgba(255,255,255,0.28)] transition duration-200 group-hover:w-8 group-hover:bg-white" />
      <span className="block h-[2px] w-9 rounded-full bg-white shadow-[0_0_10px_rgba(255,255,255,0.28)] transition duration-200 group-hover:w-10 group-hover:bg-white" />
    </span>
  );
}
